import React from 'react';
import { Check, Lock, Zap, ShieldCheck, CreditCard, ArrowRight } from 'lucide-react';
import { Countdown } from './Shared';
const pack = {
  emoji: '🏆',
  name: 'PILATES PACK COMPLETO',
  detail: '12 Tomi di Pilates Mat e Reformer + 6 Bonus in regalo',
  oldPrice: '€29.90',
  price: '€19.90',
  savings: 'RISPARMI €10',
  checkoutUrl: 'https://class-room.impultienda.ar//checkout'
};
const includedItems = ['12 Tomi completi di Pilates Mat e Reformer', '6 Bonus strategici in regalo', '+150 sessioni illustrate per livello', 'Accesso immediato a tutti i PDF'];
export const Pricing = () => {
  return <section id="precio" className="py-20 bg-brand-charcoal scroll-mt-10" data-id="element-99">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
        {/* Header & Countdown */}
        <div className="text-center mb-12" data-id="element-101">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-102">
            ⏰ PREZZO DI LANCIO
          </h2>
          <p className="text-lg text-brand-terracotta font-bold mb-8 uppercase tracking-wider" data-id="element-103">
            Offerta a tempo limitato
          </p>
          <div className="mb-6" data-id="element-104">
            <Countdown data-id="element-105" />
          </div>
          <p className="text-red-300 font-medium text-sm" data-id="element-106">
            🔴 Il prezzo sale quando scade il timer
          </p>
        </div>

        {/* Pricing Card */}
        <div className="bg-white rounded-[28px] p-6 sm:p-10 shadow-2xl" data-id="element-107">
          <div className="text-center mb-8" data-id="element-108">
            <h3 className="text-3xl sm:text-4xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-109">
              Il tuo Pack Completo
            </h3>
            <p className="text-gray-500 text-base sm:text-lg max-w-md mx-auto" data-id="element-110">
              Tutto incluso in un unico pacchetto
            </p>
          </div>

          {/* Single Pack Card */}
          <div className="rounded-2xl border-2 border-brand-terracotta bg-brand-cream p-6 sm:p-8 mb-8" data-id="element-111">
            <div className="flex items-center gap-4 mb-6" data-id="element-112">
              <div className="text-4xl sm:text-5xl flex-shrink-0" data-id="element-113">
                {pack.emoji}
              </div>
              <div className="flex-1 min-w-0" data-id="element-114">
                <div className="font-bold text-brand-charcoal text-lg sm:text-xl leading-tight mb-2" data-id="element-115">
                  {pack.name}
                </div>
                <div className="flex flex-wrap gap-1.5" data-id="element-116">
                  <span className="inline-flex items-center gap-1 bg-brand-gold text-brand-charcoal text-[10px] sm:text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-117">
                    ⭐ TUTTO INCLUSO
                  </span>
                  <span className="inline-block bg-brand-terracotta/10 text-brand-terracotta text-[10px] sm:text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-118">
                    {pack.savings}
                  </span>
                </div>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-119">
                <div className="text-xs sm:text-sm text-gray-400 line-through leading-none mb-1" data-id="element-120">
                  {pack.oldPrice}
                </div>
                <div className="text-2xl sm:text-4xl font-bold leading-none text-brand-terracotta" data-id="element-121">
                  {pack.price}
                </div>
              </div>
            </div>

            <div className="border-t border-brand-sand pt-6 space-y-3" data-id="element-122">
              {includedItems.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-123">
                  <Check className="text-green-500 flex-shrink-0 mt-0.5" size={20} data-id="element-124" />
                  <span className="text-brand-charcoal text-sm sm:text-base" data-id="element-125">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          {/* CTA Button */}
          <a href={pack.checkoutUrl} target="_blank" rel="noopener noreferrer" className="w-full bg-brand-terracotta hover:bg-brand-terracotta-dark text-white text-base sm:text-lg font-bold py-5 px-6 rounded-2xl shadow-lg shadow-brand-terracotta/30 transition-all transform hover:-translate-y-0.5 flex items-center justify-center gap-3" data-id="element-126">
            SÌ, VOGLIO IL PILATES PACK COMPLETO
            <ArrowRight size={20} data-id="element-127" />
          </a>

          <p className="text-center italic text-gray-500 text-sm mt-6 max-w-md mx-auto" data-id="element-128">
            L'opzione più scelta dagli insegnanti di Pilates
          </p>
        </div>

        {/* Trust Footer */}
        <div className="grid grid-cols-2 gap-y-4 gap-x-6 mt-10 max-w-md mx-auto text-white/80 text-sm" data-id="element-129">
          <span className="flex items-center gap-2" data-id="element-130">
            <Lock size={16} className="text-white/60" data-id="element-131" /> Pagamento sicuro
          </span>
          <span className="flex items-center gap-2" data-id="element-132">
            <Zap size={16} className="text-brand-gold" data-id="element-133" /> Accesso in 5 min
          </span>
          <span className="flex items-center gap-2" data-id="element-134">
            <ShieldCheck size={16} className="text-green-400" data-id="element-135" /> Garanzia 7
            giorni
          </span>
          <span className="flex items-center gap-2" data-id="element-136">
            <CreditCard size={16} className="text-white/60" data-id="element-137" /> Carta · Bonifico
          </span>
        </div>
      </div>

      {/* Comparison on lighter background */}
      <div className="bg-brand-cream mt-20 pt-20 pb-4" data-id="element-138">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139">
          {/* Comparison Table */}
          <div data-id="element-140">
            <h3 className="text-3xl font-serif font-bold text-brand-charcoal mb-10 text-center" data-id="element-141">
              Quanto costa NON averlo?
            </h3>
            <div className="bg-white rounded-2xl shadow-lg border border-brand-sand overflow-hidden" data-id="element-142">
              <div className="grid grid-cols-2 bg-brand-charcoal text-white p-6" data-id="element-143">
                <div className="font-bold text-lg text-center" data-id="element-144">
                  Senza PILATES 360
                </div>
                <div className="font-bold text-lg text-center text-brand-gold" data-id="element-145">
                  Con PILATES 360
                </div>
              </div>
              <div className="divide-y divide-brand-sand" data-id="element-146">
                {[['Ore a pianificare da zero ogni settimana', '5 minuti. Tutto pronto.'], ['Sessioni improvvisate senza progressione reale', '+150 sessioni illustrate per livello'], ['Gruppi senza un sistema chiaro', 'Struttura chiara per ogni livello'], ['Sempre gli stessi esercizi', "100 variazioni pronte all'uso"], ['Paura che un allievo si faccia male', 'Checklist di sicurezza inclusa'], ['Finire ogni lezione mentalmente esausta', 'Arrivi con tutto risolto'], ['Impossibilità di giustificare un aumento di prezzo', 'Sistema documentato e professionale']].map((row, i) => <div key={i} className="grid grid-cols-2 p-6 hover:bg-brand-cream transition-colors" data-id="element-147">
                    <div className="text-gray-600 pr-4" data-id="element-148">{row[0]}</div>
                    <div className="text-brand-charcoal font-semibold pl-4 border-l border-brand-sand flex items-center gap-3" data-id="element-149">
                      <Check className="text-green-500 flex-shrink-0" size={20} data-id="element-150" />{' '}
                      {row[1]}
                    </div>
                  </div>)}
              </div>
            </div>
            <p className="text-center text-xl font-serif font-bold text-brand-charcoal mt-8" data-id="element-151">
              Lunedì puoi improvvisare o entrare con tutto risolto. Tu decidi.
            </p>
          </div>
        </div>
      </div>
    </section>;
};